<template>
  <section class="courses-wrapper mt-4_5">
    <div class="top-section">
      <b-row>
        <b-col cols="6">
          <h3 class="heading">
            {{ courseType === "live" ? "Live " : "" }}Courses
          </h3>
        </b-col>
      </b-row>
    </div>
    <div>
      <div v-for="(items, name) in courses">
        <h5
          class="text-capitalize font-weight-light"
          v-if="items.length > 0 && courseType === 'live'"
        >
          {{ name }} courses
        </h5>
        <!--<b-button @click="toggleBusy">Toggle Busy State</b-button>-->
        <b-table
          :fields="fields"
          :items="items"
          :per-page="perPage"
          :busy="isBusy"
          class="mt-3"
          thead-class="hidden_header"
        >
          <!-- A custom formatted column -->
          <template v-slot:cell(name)="data">
            <p class="title">{{ data.value }}</p>
          </template>
          <template v-slot:cell(category_name)="data">
            <b-badge>{{ data.value }}</b-badge>
          </template>
          <template v-slot:cell(course_duration)="data">
            <div class="status">
              <div class="text">{{ data.value }}</div>
              <b-progress height="2px" :value="value" :max="max"></b-progress>
            </div>
          </template>
          <template v-slot:cell(edit)="data">
            <div @click="editCourse(data)">
              <b-link>Edit</b-link>
            </div>
          </template>
          <template v-slot:cell(discussions)="data">
            <div @click="addMoreVideo(data)" v-if="courseType === 'regular'">
              <b-link> Add More Videos</b-link>
            </div>
            <div
              @click="changeSchedule(data)"
              v-if="courseType === 'live' && data.item.Status != 'previous'"
            >
              <b-link> Change Schedule </b-link>
            </div>
          </template>
          <template v-slot:cell(room_number)="data">
            <div v-if="courseType === 'live' && data.item.Status === 'today'">
              <b-link
                :to="{
                  path: '/admin/live_start',
                  query: {
                    roomNumber: data.value
                  }
                }"
                ><font-awesome-icon icon="broadcast-tower"></font-awesome-icon
              ></b-link>
            </div>
          </template>
          <template v-slot:cell(show_details)="row">
            <a href="#!" class="text-dark" @click.prevent="row.toggleDetails">
              <font-awesome-icon icon="eye"></font-awesome-icon>
            </a>
          </template>
          <template v-slot:table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <template v-slot:row-details="row">
            <show-more :row-data="row.item" :course-type="courseType"></show-more>
          </template>
        </b-table>
        <button
          class="more-button"
          @click="perPage = perPage + 5"
          v-if="items.length - perPage > 0"
        >
          <span> {{ items.length - perPage }} more courses</span>
          <font-awesome-icon icon="angle-down" size="md" />
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import ShowMore from "./ShowMore";

export default {
    components: {ShowMore},
    name: "course-listing-table",
  data() {
    return {
      isBusy: false,
      max: 100,
      value: 20,
      perPage: 5,
      fields: [
        { key: "name", label: "Title" },
        { key: "category_name", label: "Category" },
        { key: "course_duration", label: "Progress" },
        { key: "edit", label: "Edit" },
        { key: "discussions", label: "Discussions" },
        { key: "room_number", label: "Start Live" },
        { key: "show_details", label: "View" }
      ],
      courses: {
        regular: [],
        today: [],
        upcoming: [],
        previous: []
      }
    };
  },
  computed: {
    ...mapGetters("user", ["getTeacherCourses", "getTeacherLiveCourses"])
  },
  methods: {
    setCourseData() {
      this.courses = {
        regular: [],
        today: [],
        upcoming: [],
        previous: []
      };
      if (this.courseType === "regular") {
        this.getTeacherCourses.forEach(course => {
          course.Status = "regular";
          this.courses.regular.push(course);
        });
      } else if (this.courseType === "live") {
        if (this.getTeacherLiveCourses.todayLiveCourses)
          this.getTeacherLiveCourses.todayLiveCourses.forEach(course => {
            course.Status = "today";
            this.courses.today.push(course);
          });
        if (this.getTeacherLiveCourses.upcomingLiveCourses)
          this.getTeacherLiveCourses.upcomingLiveCourses.forEach(course => {
            course.Status = "upcoming";
            this.courses.upcoming.push(course);
          });
        if (this.getTeacherLiveCourses.previousLiveCourses)
          this.getTeacherLiveCourses.previousLiveCourses.forEach(course => {
            course.Status = "previous";
            this.courses.previous.push(course);
          });
      }
    },
    changeSchedule(item) {
      this.$router.push({
        path: "/admin/live-schedule",
        query: {
          courseId: item.item.course_id,
          courseName: item.item.name,
          totalSession: item.item.total_session
        }
      });
    },
    editCourse(item) {
      this.$router.push({
        path: "/admin/add-course",
        query: {
          courseId: item.item.course_id,
          courseType: this.courseType
        }
      });
    },
    addMoreVideo(item) {
      this.$router.push({
        path: "/admin/add-video",
        query: {
          courseId: item.item.course_id,
          courseName: item.item.name,
          totalVideos: item.item.total_videos
        }
      });
    }
  },
  mounted() {
    this.setCourseData();
  },
  props: {
    courseType: String
  },
  watch: {
    getTeacherCourses() {
      this.setCourseData();
    },
    getTeacherLiveCourses() {
      this.setCourseData();
    }
  }
};
</script>

<style scoped></style>
